<template>
    <div class="section">
        <div class="columns is-multiline is-centered">
            <div class="column is-one-third">
                <div class="has-text-centered">
                    <p class="is-size-7">Luego de aplicado el cambio, tendras que volver a iniciar sesion con la nueva clave.</p>
                </div>
                <b-field label="Clave actual">
                    <b-input
                    v-model="data.oldPassword"
                    type="password"
                    >
                    </b-input>
                </b-field>
                <b-field label="Nueva clave">
                    <b-input
                    v-model="data.newPassword"
                    type="password"
                    >
                    </b-input>
                </b-field>
                <b-field label="Vuelve a ingresar la nueva clave">
                    <b-input
                    v-model="data.newPassword2"
                    type="password"
                    >
                    </b-input>
                </b-field>

                <div class="has-text-centered">
                    
                    <b-button
                        type="is-custom"
                        rounded
                        @click="updatePassword"
                        :loading="loading">
                            <b-icon icon="save" size="is-small"></b-icon>
                            Cambiar clave
                        </b-button>
                    </div>
                </div>
        </div>
    </div>
</template>

<script>
import { patchHandler } from '../../../../services/http'
export default {
    props:{
        passwordUrl:{
            type:String,
            default:""
        }
    },
    data(){
        return{
            data:{},
            loading:false
        }
    },
    methods:{
        async updatePassword(){
            let error = {
                resource:"notify",
                text:"Verifica que la clave actual es la correcta, y que las nuevas coinciden"
            }
            let success = {
                resource:"notify",
                text:"Clave actualizada con exito"
            }
            this.loading = true
            let res = await patchHandler(this.passwordUrl, this.data, {error, success})
            this.loading = false
            console.log(res)
            this.data = {}
            if (res.status == 200){
                window.location.href = '/user/login/'
            }
            
        }
    }
}
</script>

<style lang="scss" scoped>
.is-custom{
    color:var(--text-color);
    background:var(--primary);
}
</style>